<template>
  <div
    class="edit-interface"
    :class="{ 'edit-interface--expanded': expanded }"
    :key="intfKey"
  >
    <div
      style="width: fit-content;"
      v-if="$vuetify.breakpoint.width >= minDesktopWidth"
      class="edit-interface__back d-flex align-center mb-2 link-default"
      @click="goBack"
    >
      <apio-icon size="16" lightModeColour="cyan" name="chevron-left" />Back
    </div>
    <div
      style="width: fit-content;"
      v-if="$vuetify.breakpoint.width <= minDesktopWidth"
      class="edit-interface__back d-flex align-center mb-2 link-default"
      @click="goBack"
    >
      <apio-icon
        class="mr-2"
        size="16"
        lightModeColour="cyan"
        name="chevron-left"
      />Back
      <v-spacer />
    </div>
    <div
      class="edit-interface__actions-bar"
      v-if="$vuetify.breakpoint.width >= minDesktopWidth"
    >
      <p class="mt-5 mr-2">Interface Name:</p>
      <v-text-field
        class="edit-interface__interface-name"
        dense
        outlined
        v-model="interfaceName"
        :hide-details="true"
        @change="toggleEditInterfaceName({ saveChange: true })"
        prepend
      >
      </v-text-field>
      <v-spacer />
      <apio-button
        class="mr-2"
        button-text-size="tiny"
        button-size="small"
        button-type="primary"
        button-icon=""
        @click.native="saveInterface"
      >
        SAVE
        <apio-icon
          class="ml-1"
          name="ui-save"
          lightModeColour="white"
          darkModeColour="white"
        />
      </apio-button>

      <apio-button
        class="mr-2"
        button-text-size="tiny"
        @click.native="uploadJSONDialog = true"
        button-size="small"
        button-type="secondary"
        @mouseover.native="onSecondaryButtonMouseOver('import')"
        @mouseout.native="onSecondaryButtonMouseOut('import')"
        >IMPORT
        <apio-icon
          class="ml-1"
          name="ui-upload"
          :lightModeColour="secondaryButtonIconColours.import.color"
          :darkModeColour="secondaryButtonIconColours.import.color"
      /></apio-button>
      <apio-button
        button-text-size="tiny"
        @click.native="downloadJSON"
        class="mr-2"
        button-size="small"
        button-type="secondary"
        @mouseover.native="onSecondaryButtonMouseOver('export')"
        @mouseout.native="onSecondaryButtonMouseOut('export')"
        >EXPORT
        <apio-icon
          class="ml-1"
          name="ui-download"
          :lightModeColour="secondaryButtonIconColours.export.color"
          :darkModeColour="secondaryButtonIconColours.export.color"
      /></apio-button>

      <!-- <apio-switch
        class="white-switch"
        small
        v-on:change="
          simulator = false;
          debug ? debugOff() : debugOn();
        "
        ><template slot="right-label"
          ><apio-icon
            lightModeColour="apioshade3"
            darkModeColour="apioshade3"
            name="ui-bug" /></template
      ></apio-switch> -->
      <apio-switch
        :value="simulator"
        small
        v-on:change="
          debug = false;
          simulator = !simulator;
        "
        ><template slot="right-label"
          ><apio-icon
            lightModeColour="apioshade3"
            darkModeColour="apioshade3"
            name="ui-simulation" /></template
      ></apio-switch>

      <icon-menu>
        <apio-button
          slot="icon"
          class="ml-3"
          button-text-size="tiny"
          button-size="small"
          button-type="primary"
          button-icon=""
        >
          Version {{versionNumber}}
        </apio-button>
        <div slot="icon-menu-list" class="vermenu">
          <v-list-item
            v-for="(ver, idx) in versions"
            :key="idx"
            @click="setVersion(idx)"
            >
            <div>
            <div class="small">Version {{ver.index}}: {{ ver.username }}</div>
            <div class="xsmall">{{ver.date}}</div>
            </div>
          </v-list-item>
        </div>
      </icon-menu>

    </div>

    <div
      :class="{ 'edit-interface__panes-wrapper--expanded': expanded }"
      class="edit-interface__panes-wrapper d-flex mb-4"
    >
      <div id="steps-pane" class="edit-interface__step-pane">
        <div class="edit-interface__step-actions">
          <span class="small-extra-bold">Input type</span>
          <span
            @click="addStepCallback"
            class="edit-interface__add-step d-flex p2-extra-bold cyan--text"
          >
            ADD STEP
            <apio-icon
              size="16"
              name="ui-plus-small"
              lightModeColour="cyan"
              darkModeColour="cyan"
            />
          </span>
        </div>
        <EditStep
          class="edit-interface__step"
          :item="intf.input"
          skey="-1"
          prefix="input"
          :cursorpos="cursorpos"
          :debug="debug"
          :inputs="inputs"
          :simbundle="simbundle"
          :simulator="simulator"
          :variables="env"
          :queues="editor.queues"
          :paused="editor.paused"
          @disableSimulator="
            simulator = false;
            debug = false;
          "
        />
        <div v-if="!simulator && !debug" style="height: 8px" />
        <Queue
          v-if="simulator || debug"
          :item="intf.input"
          prefix="input"
          skey="-1"
          :simbundle="simbundle"
          :simulator="simulator"
          :debug="debug"
          :queues="editor.queues"
          :paused="editor.paused"
        />
        <EditSteps
          v-if="list"
          v-model="list"
          prefix="steps"
          :cursorpos="cursorpos"
          :debug="debug"
          :steps="steps"
          :simbundle="simbundle"
          :simulator="simulator"
          :variables="env"
          :queues="editor.queues"
          :paused="editor.paused"
          @disableSimulator="
            simulator = false;
            debug = false;
          "
        />
      </div>

      <div id="divider" class="divider" @click="toggleExpansion">
        <apio-icon
          v-if="expanded && horizontal"
          name="chevron-right"
          size="16"
          :lightModeColour="chevronIconLightModeColour"
          :darkModeColour="chevronIconDarkModeColour"
        />
        <apio-icon
          v-else-if="horizontal"
          name="chevron-left"
          size="16"
          :lightModeColour="chevronIconLightModeColour"
          :darkModeColour="chevronIconDarkModeColour"
        />
        <apio-icon
          v-else-if="expanded && !horizontal"
          name="chevron-down"
          size="16"
          :lightModeColour="chevronIconLightModeColour"
          :darkModeColour="chevronIconDarkModeColour"
        />
        <apio-icon
          v-else-if="!horizontal"
          name="chevron-up"
          size="16"
          :lightModeColour="chevronIconLightModeColour"
          :darkModeColour="chevronIconDarkModeColour"
        />
      </div>

      <div id="details-pane" class="edit-interface__details-pane">
        <v-card flat outlined class="editor-inner__col" v-if="selected">
          <h2 class="d-flex mb-2 align-center">
            <img
              v-if="selected.module"
              :src="
                '/img/icons/' +
                (!cursorpos.startsWith('input') ? 'step' : 'input') +
                '_' +
                selected.module +
                '.svg'
              "
              class="edit-interface__details-pane-icon mr-4"
            />
            <span class="h3"> {{ selected.shortname }}</span>
          </h2>

          <p
            class="mb-2"
            v-if="cursorpos.startsWith('input')"
            v-html="docs['input_' + selected.module]"
          ></p>
          <p class="mb-2" v-else v-html="docs['step_' + selected.module]"></p>

          <div v-if="active == 2">

            <EditorForm
              v-if="cursorpos.startsWith('input')"
              v-model="selected"
              :settings="inputs[selected.module]"
              :conf="inputs"
              :steps="stepNames"
              mode="input"
              :env="env"
            />
            <EditorForm
              v-else
              v-model="selected"
              :settings="steps[selected.module]"
              :steps="stepNames"
              :conf="steps"
              mode="step"
              :env="env"
            />
          </div>
        </v-card>
        <v-card
          class="edit-interface__add-or-select-step-wrapper"
          flat
          outlined
          v-else
        >
          <div v-if="list && list.length === 0">
            Select input type (on the left),<br/>
            add one or more steps<br />
            to begin editing interface<br />
            declaration
          </div>
          <span v-else
            >Select a step<br />
            to begin editing</span
          >
        </v-card>
      </div>
    </div>
    <!-- sticky-top in TheContainer.vue -->
    <portal to="sticky-top">
      <div class="d-flex mb-3">
        <v-spacer /><apio-button
          class="mr-2"
          button-text-size="tiny"
          button-size="small"
          button-type="secondary"
          button-icon=""
          @click.native="saveInterface"
        >
          SAVE
          <apio-icon
            class="ml-1"
            name="ui-save"
            lightModeColour="cyan"
            darkModeColour="cyan"
          />
        </apio-button>
        <apio-button
          button-text-size="tiny"
          button-size="small"
          button-type="secondary"
          button-icon=""
        >
          PUBLISH
          <apio-icon
            class="ml-1"
            name="nav-cog"
            lightModeColour="cyan"
            darkModeColour="cyan"
          />
        </apio-button>
      </div>
      <v-expansion-panels active-class="" class="" flat>
        <v-expansion-panel @click="onExpansionPanelClick" color="purple">
          <v-expansion-panel-header
            :class="{ 'border-radius': headerBackgroundColor === 'cyan' }"
            class="white--text"
            :color="headerBackgroundColor"
          >
            <div class="p1-extra-bold">Build controls</div>
            <template v-slot:actions>
              <apio-icon
                lightModeColour="white"
                darkModeColour="white"
                :name="headerIconName"
              >
                $expand
              </apio-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content color="purple" class="pa-0">
            <v-text-field
              class="mb-4"
              style="width: 100%"
              dense
              outlined
              v-model="interfaceName"
              :hide-details="true"
              @change="toggleEditInterfaceName({ saveChange: true })"
              prepend
            >
            </v-text-field>
            <div class="d-flex mb-4">
              <!-- <apio-switch
                class="white-switch"
                small
                v-on:change="
                  simulator = false;
                  debug ? debugOff() : debugOn();
                "
                ><template slot="right-label"
                  ><apio-icon
                    lightModeColour="apioshade3"
                    darkModeColour="apioshade3"
                    name="ui-bug" /></template
              ></apio-switch> -->
              <apio-switch small v-on:change="simToggle"
                ><template slot="right-label"
                  ><apio-icon
                    lightModeColour="apioshade3"
                    darkModeColour="apioshade3"
                    name="ui-simulation" /></template
              ></apio-switch>
            </div>
            <div class="d-flex">
              <apio-button
                class="mr-2"
                button-text-size="tiny"
                @click.native="uploadJSONDialog = true"
                button-size="small"
                button-type="secondary"
                @mouseover.native="onSecondaryButtonMouseOver('import')"
                @mouseout.native="onSecondaryButtonMouseOut('import')"
                >IMPORT
                <apio-icon
                  class="ml-1"
                  name="ui-upload"
                  :lightModeColour="secondaryButtonIconColours.import.color"
                  :darkModeColour="secondaryButtonIconColours.import.color"
              /></apio-button>
              <apio-button
                button-text-size="tiny"
                @click.native="downloadJSON"
                button-size="small"
                button-type="secondary"
                @mouseover.native="onSecondaryButtonMouseOver('export')"
                @mouseout.native="onSecondaryButtonMouseOut('export')"
                >EXPORT
                <apio-icon
                  class="ml-1"
                  name="ui-download"
                  :lightModeColour="secondaryButtonIconColours.export.color"
                  :darkModeColour="secondaryButtonIconColours.export.color"
              /></apio-button>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </portal>

    <v-dialog max-width="600" v-model="uploadJSONDialog">
      <v-card>
        <v-toolbar flat color="apioshade3" class="white--text h2 mb-6">
          <div class="white--text run-step__title">Upload JSON file</div>
          <v-spacer></v-spacer>
          <apio-button
            button-type="get-started"
            button-size="small"
            @click.native="uploadJSONDialog = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
        </v-toolbar>
        <div class="px-4" id="loadscreen" hide-footer title="Upload JSON File">
          <p>
            The uploaded JSON program code file will replace current code in the
            editor, will not be automatically saved.
          </p>
          <label>Upload:</label>
          <input type="file" @change="readFile" />
          <br />
          <div class="mt-2">{{ uploadMessage }}</div>
        </div>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <portal to="right-hand-nav-drawer">
      <v-navigation-drawer
        v-model="add_step"
        disable-resize-watcher
        disable-route-watcher
        hide-overlay
        v-if="add_step"
        width="360"
        absolute
        right
        class="edit-interface__available-steps"
      >
        <div class="edit-interface__available-steps-header">
          <apio-button
            button-type="get-started"
            button-size="small"
            @click.native="add_step = false"
            class="edit-interface__available-steps-header--close"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
          <span class="edit-interface__available-steps-header--title"
            >Add steps</span
          >
        </div>
        <v-text-field
          id="search"
          class="pt-4 pb-2 pl-5 pr-5"
          ref="stepsearch"
          dense
          outlined
          v-model="msearch"
          placeholder="Search step name..."
          hide-details="auto"
        />

        <draggable
          :list="stepsres"
          :clone="addStep"
          ghost-class="ghost"
          drag-class="dragging-item"
          class="steplist"
          @change="changed"
          @start="begin"
          :group="{ name: 'steps', pull: 'clone', put: false }"
          ><div
            class="edit-interface__available-step"
            v-for="(step, sk) in stepsres"
            :key="sk"
          >
            <apio-icon
              lightModeColour="apioshade2"
              darkModeColour="apioshade2"
              name="ui-drag"
            />
            <img
              v-if="step.name !== undefined"
              :src="'/img/icons/' + step.name + '.svg'"
              class="edit-interface__available-steps__image"
            />
            <div class="edit-interface__available-step-label">
              {{ step.title }}
            </div>
            <div class="edit-interface__available-step-add-button">
              <apio-icon
                @click.native="
                  addStepManual(step);
                  cursorMove({ pos: 'steps-steps.' + list.length });
                "
                name="ui-circle-plus"
                lightModeColour="white"
                darkModeColour="white"
              />
            </div>
          </div>
        </draggable>
      </v-navigation-drawer>
    </portal>
    <apio-snackbar
      :text="snackBarText"
      :status="snackBarStatus"
      :snackbar="snackbar"
      @close="snackbar = false"
    />
    <!-- <v-dialog max-width="500" v-model="bvModalAutoSave">
      <v-card>
        <v-toolbar flat color="apioshade3" class="white--text h2 mb-6">
          <div class="white--text run-step__title">Unsaved changes found</div>
          <v-spacer></v-spacer>
          <apio-button
            button-type="get-started"
            button-size="small"
            @click="bvModalAutoSave = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
        </v-toolbar>
        <v-card-text class="pb-0">
          <div>
            <p>Would you like to save the auto saved version?</p>
          </div>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <apio-button
            class="mr-2"
            button-size="small"
            @click.native="saveAutoSavedInterface"
            color="error"
            >Apply my changes</apio-button
          >
          <apio-button
            class="mr-2"
            button-size="small"
            @click.native="
              loadProjects(true);
              bvModalAutoSave = false;
            "
            >Don't save yet</apio-button
          >
          <apio-button
            class="mr-2"
            button-size="small"
            button-type="delete"
            @click.native="cancelAutoSave"
            >Ignore my changes</apio-button
          >
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <!-- <v-dialog max-width="500" v-model="bvModalAutoSaveConflict">
      <v-card flat>
        <v-toolbar flat color="apioshade3" class="white--text h2 mb-6">
          <div class="white--text run-step__title">Conflict</div>
          <v-spacer></v-spacer>
          <apio-button
            button-type="get-started"
            button-size="small"
            @click="bvModalAutoSaveConflict = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
        </v-toolbar>
        <v-card-text class="pb-0">
          <div>
            <p>
              Your autosaved version {{ storedInterfaceVersion }} is different
              to the server version {{ serverVersion }} <br /><br />
              User {{ serverModifiedUser }} modified this interface last.
              <br /><br />
              Choose an option from the following
            </p>
          </div>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <apio-button            class="mr-2"
            button-size="small" @click.native="saveAutoSavedInterface" button-type="delete"
            >Apply my changes</apio-button
          >
          <apio-button            class="mr-2"
            button-size="small"
            @click.native="
              loadProjects(true);
              bvModalAutoSaveConflict = false;
            "
            >Don't save yet</apio-button
          >
          <apio-button            class="mr-2"
            button-size="small" @click.native="cancelAutoSaveConflict">Ignore my changes</apio-button>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
  <!-- <div :key="intfKey" class="ma-0 pa-0">

    <v-dialog v-model="bvModalEditor">
      <v-card>
        <div class="editor-wrapper">
          <Editor v-model="editor.content" />
        </div>
        <v-card-actions>
          <v-btn @click="bvModalEditor = false">Close</v-btn>
          <v-btn class="mt-3" block @click="payload = editor.content"
            >Use as payload</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="500" v-model="bvModalSaveRecipe">
      <v-card>
        <v-card-title>Save as Recipe</v-card-title>
        <v-card-text>
          <v-text-field
            id="recipename"
            outlined
            dense
            hide-details="auto"
            required
            placeholder="Recipe Name"
            v-model="recipeName"
            ref="inputModalRecipeName"
          />
          <v-textarea
            placeholder="Write about the recipe's purpose and use cases"
            v-model="recipeDesc"
          />
        </v-card-text>
        <v-card-text color="red">{{ recipeNameError }}</v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="bvModalSaveRecipe = false">Close</v-btn>
          <v-btn :disabled="!recipeName || !recipeDesc" @click="saveRecipe"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>



  </div> -->
</template>


<script>
import Vue from "vue";
import VueHotkey from "v-hotkey";
import { filter, map, values, isEqual, flattenDeep, concat } from "lodash";
import draggable from "vuedraggable";
Vue.use(VueHotkey);
import { mapState, mapActions } from "vuex";

import request from '@/API/';

const compare = function (a, b) {
  const stepA = a.title.toUpperCase();
  const stepB = b.title.toUpperCase();

  let comparison = 0;
  if (stepA > stepB) {
    comparison = 1;
  } else if (stepA < stepB) {
    comparison = -1;
  }
  return comparison;
};

export default {
  name: "EditInterface",
  props: ["id", "item"],
  components: {
    EditorForm: () => import("@/components/Editor/Form.vue"),
    EditSteps: () => import("@/components/Editor/EditSteps"),
    EditStep: () => import("@/components/Editor/EditStep"),
    // Editor: () => import("@/components/Editor.vue"),
    Queue: () => import("@/components/Editor/Queue"),
    ApioSwitch: () => import("@/components/Misc/Switch.vue"),
    IconMenu: () => import("@/components/Misc/IconMenu"),
    draggable,
  },
  computed: {
    ...mapState({
      editor: (state) => state.socket.editor,
      socket: (state) => state.socket.socket,
      datamapper: (state) => state.datamapper,
      horizontal() {
        return this.$vuetify.breakpoint.width >= 1024;
      },
    }),
    getAlertsButtonIconColours() {
      if (this.intf?.info?.alert) {
        return {
          lightModeColour: "white",
          darkModeColour: "white",
        };
      }

      return {
        lightModeColour: "cyan",
        darkModeColour: "white",
      };
    },
    getAlertsButtonType() {
      return this.intf?.info?.alert ? "primary" : "secondary";
    },
    chevronIconLightModeColour() {
      return this.expanded ? "white" : "cyan";
    },
    chevronIconDarkModeColour() {
      return this.expanded ? "white" : "cyan";
    },
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    storedInterfaceVersion() {
      return localStorage.getItem("interface.version." + this.$route.query.i);
    },
    storedInterfaceModifier() {
      return localStorage.getItem("interface.modifier." + this.$route.query.i);
    },
    autoSavedInterface() {
      return JSON.parse(
        localStorage.getItem("autosave." + this.$route.query.i)
      );
    },
    endpointName: () => {
      if (this === undefined) {
        return "";
      }
      return this.$route.query.p + "." + this.$route.query.n;
    },
    keymap() {
      return {
        "ctrl+s": this.saveInterface,
      };
    },
    stepNames() {
      let sn = this.getSteps("", this.list);
      return sn;
    },
    input: {
      get() {
        return this.inputdata;
      },
      set(v) {
        this.inputdata = v;
        this.intf.input = v[0];
      },
    },
    list: {
      get() {
        return this.listdata;
      },
      set(v) {
        this.listdata = v;
        this.intf.steps = v;
      },
    },
    stepsres() {
      if (this == undefined) return [];
      if (this.msearch == "") {
        const stepsres = filter(values(this.steps), function (item) {
          return item.name.startsWith("step_");
        });
        return stepsres.sort(compare);
      }
      let self = this;
      const stepsres = filter(values(this.steps), function (item) {
        return (
          item.title.toLowerCase().indexOf(self.msearch.toLowerCase()) > -1 && item.name.startsWith("step_")
        );
      });

      if (this.msearch.length) {
        return stepsres;
      }
      return [];
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  data() {
    return {
      stepSearchText: "",
      headerBackgroundColor: "cyan",
      headerIconName: "chevron-down",
      secondaryButtonIconColours: {
        alerts: {
          color: "cyan",
          light: {
            normal: "cyan",
            hover: "black",
          },
          dark: {
            normal: "cyan",
            hover: "cyan",
          },
        },
        import: {
          color: "cyan",
          light: {
            normal: "cyan",
            hover: "black",
          },
          dark: {
            normal: "cyan",
            hover: "cyan",
          },
        },
        export: {
          color: "cyan",
          light: {
            normal: "cyan",
            hover: "black",
          },
          dark: {
            normal: "cyan",
            hover: "cyan",
          },
        },
      },
      interfaceName: this.$route.query.il,
      minDesktopWidth: 1004,
      expanded: false,
      editingInterfaceName: false,
      connected: true,
      debug: false,
      simulator: false,
      uploadMessage: "",
      listdata: [],
      intf: {},
      versions: {},
      versionNumber: 1,
      inputdata: [],
      stories: [],
      cursorpos: "",
      steps: {},
      inputs: {},
      parts: {},
      env: {},
      name: "",
      value: {},
      status: "Initialised",
      simmessage: "",
      simstate: "",
      simbundle: {},
      payload: "",
      selected: null,
      docs: {},
      active: 0,
      uploadJSONDialog: false,
      bvModalEditor: false,
      bvModalSaveRecipe: false,
      bvModalAutoSave: false,
      bvModalAutoSaveConflict: false,
      add_step: false,
      msearch: "",
      debugapps: [],
      intfKey: "",
      qerr: "",
      recipeName: "",
      recipeDesc: "",
      recipeNameError: "",
      serverModifiedUser: "",
      serverVersion: "",
      intfCopy: {},
      modifier: "",
      version: 0,
      snackbar: false,
      snackBarText: "",
      snackBarStatus: null,
      stepnames: [],
      loaded: false,
    };
  },
  mounted() {
    this.$root.$on("cursor-move", this.cursorMove);
    this.$root.$on("drag-event", this.dragEvent);
    this.$root.$on("getcontent", this.getContent);
    this.$root.$on("resumequeue", this.resumeQueue);
    this.$root.$on("pausequeue", this.pauseQueue);
    this.$root.$on("intf-change", this.autoSave);
    this.$root.$on("step-del", this.delStep);
    this.$root.$on("step-add", this.addStep);
    this.$root.$on("step-changed", this.changed);
    this.$root.$on("set-module", this.setModule);
    this.$root.$on("sim-delete", this.simDelete);
    this.$root.$on("sim-pintoggle", this.simPinToggle);
    this.$root.$on("sim-empty", this.simEmptyQueue);
    this.$root.$on("sim-delfrom", this.simDelFromQueue);
    this.$root.$on("sim-step", this.simStep);
    this.$root.$on("sim-disable", this.simDisable);
    this.$root.$on("expand-step-details", this.expandStepDetails);
    this.$root.$on("add-step-sidebar", this.addStepCallback);

    this.$root.$on("closeDataMapper", (dataMapperJSON) => {
      this.closeDataMapper(dataMapperJSON);
    });

    this.loadProjects();
    this.getDocs();

    //Clear Vuex datamapper data
    this.clearDataMapperData();
    this.intfKey = Math.random();
  },
  watch: {
    intf: {
      handler(newVal) {
        if (this.intfCopy.info && !isEqual(newVal, this.intfCopy)) {
          //TODO: Look at this .. it is being called when it shouldn't
          // this.autoSave();
        }
        // add a dot if we have that name already
        var intfNames = [];
        if (newVal.input != undefined && newVal.input.shortname != undefined) {
          intfNames.push(newVal.input.shortname);
        }
        if (Array.isArray(newVal.steps)) {
          newVal.steps.forEach(item => {
            while (intfNames.includes(item.shortname)) {
              item.shortname += ".";
            }
            intfNames.push(item.shortname);
          })
        }
        this.intfNames = intfNames;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["clearDataMapperData", "setCurrentStep"]),
    goBack() {
      this.$router.push('/build/?c=' + this.$router.history.current.query.c);
      this.$root.$emit('disposeCompletionProvider')
    },
    getVersions(data) {
      var versions = [];
      Object.keys(data).forEach(function (index) {
        var i = Object.keys(data).length - index;
        if (data[index].metadata == undefined) {
          console.log('invalid metadata', data[index])
          var val = { username: '-', timestamp: '' };
          val.data = JSON.parse(data[index].data)
          val.index = index;
          versions[i] = val;
          return
        }
        val = JSON.parse(data[index].metadata);
        if (val == null) {
          val = { username: 'none', timestamp: '' };
        }
        if (val.timestamp != undefined) {
          var d = new Date(Math.floor(val.timestamp / 1000000));
          val.date = d.toLocaleDateString("en-GB")+' '+d.toLocaleTimeString("en-GB");
        }
        val.data = JSON.parse(data[index].data);
        val.index = index;
        versions[i] = val;
        });
        return versions;
    },
    setVersion(index) {
      console.log('setting version', index)
      if (this.versions[index] != undefined) {
        this.intf = this.versions[index].data;
        if (this.intf.steps === undefined) {
          this.intf.steps = [];
        }
        this.list = this.intf.steps;
        this.input = [this.intf.input];
        this.value = this.intf.input;
        this.versionNumber = this.versions[index].index;
      }
    },
    addStepCallback() {
      this.add_step = true;
      setTimeout(() => {
        this.$refs.stepsearch.focus();
      }, 300);
    },
    expandStepDetails() {
      this.toggleExpansion();
    },
    onExpansionPanelClick(event) {
      if (
        event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        this.headerBackgroundColor = "cyan";
        this.headerIconName = "chevron-down";
      } else {
        this.headerBackgroundColor = "purple";
        this.headerIconName = "chevron-up";
      }
    },
    toggleExpansion() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        document.getElementById("steps-pane").style.display = "none";
        document
          .getElementById("details-pane")
          .classList.add("edit-interface__details-pane--expanded");
        document.getElementById("divider").classList.add("divider--expanded");

        this.$root.$emit('toggled-interface-expansion');
      } else {
        document.getElementById("steps-pane").style.display = "block";
        document
          .getElementById("details-pane")
          .classList.remove("edit-interface__details-pane--expanded");
        document
          .getElementById("divider")
          .classList.remove("divider--expanded");
      }
    },
    onSecondaryButtonMouseOver(index) {
      return (this.secondaryButtonIconColours[index].color =
        this.secondaryButtonIconColours[index][this.theme].hover);
    },
    onSecondaryButtonMouseOut(index) {
      return (this.secondaryButtonIconColours[index].color =
        this.secondaryButtonIconColours[index][this.theme].normal);
    },
    toggleEditInterfaceName({ saveChange = false }) {
      // ONLY SAVE ON CHANGE
      if (saveChange === true) {
        this.renameInterface();
      }
      this.editingInterfaceName = !this.editingInterfaceName;
    },
    autoSave() {
      localStorage.setItem(
        "autosave." + this.$route.query.i,
        JSON.stringify(this.intf)
      );
    },
    closeDataMapper(dataMapperJSON) {
      this.intf.steps[this.datamapper.currentStep].data = dataMapperJSON;
    },
    saveRecipe() {
      request
        .post("/editor/saverecipe?c=" + this.$route.query.c, {
          title: this.recipeName,
          description: this.recipeDesc,
          recipe: JSON.stringify(this.intf),
        })
        .then((res) => {
          this.docs = res.data;
          this.bvModalSaveRecipe = false;
        })
        .catch((err) => {
          this.recipeNameError = err;
        });
    },
    getSteps(prefix, list) {
      return flattenDeep(
        map(list, (m) => {
          if (m == undefined || m.module == undefined) {
            return "";
          }
          if (m.module != "switch") return prefix + m.shortname;
          if (m.switch == undefined || m.switch.cases == undefined) {
            return prefix + m.shortname;
          }
          let all = [];
          for (let i = 0; i < m.switch.cases.length; i++) {
            all.push(
              this.getSteps(
                prefix + "." + m.shortname + "." + i + ".",
                m.switch.cases[i].steps
              )
            );
          }
          return concat(prefix + m.shortname, all);
        })
      );
    },
    getDocs() {
      request.get("/editor/docs?a=" + this.$route.query.a).then((res) => {
        this.docs = res.data;
      });
    },
    getSelected(list, id) {
      if (id.includes(".")) {
        const prefix = id.substr(0, id.indexOf("."));
        const suffix = id.slice(prefix.length + 1);
        if (prefix === "steps") {
          let pos = parseInt(id.slice(prefix.length + 1));
          pos = pos - 1;
          return list[pos];
        }
        if (list[prefix].module == "loop") {
          return this.getSelected(list[prefix].loop.steps, suffix);
        }
        if (list[prefix].module == "ifstep") {
          return this.getSelected(list[prefix].ifstep.steps, suffix);
        }
        if (list.switch !== undefined) {
          const selCase = list.switch.cases.find((item) => {
            return item.shortname.replace(".", "_") === prefix;
          });
          if (selCase !== undefined) {
            return this.getSelected(selCase.steps, suffix);
          }
          return {};
        }
        return this.getSelected(list[prefix], suffix);
      } else {
        return list[id];
      }
    },
    dragEvent() {
      this.simmessage = "";
    },
    cursorMove(p) {
      this.doc = "";
      if (this.active == 1) {
        return;
      }
      this.active = 1;
      setTimeout(() => {
        this.active = 2;
      }, 100);
      this.cursorpos = p.pos;
      this.setCurrentStep(p.pos);
      if (this.cursorpos === "") {
        this.selected = null;
        return;
      }
      if (this.cursorpos.startsWith("input.")) {
        this.selected = this.input[0];
        return;
      }
      this.selected = this.getSelected(this.list, this.cursorpos.slice(6));
    },
    loadAutoSavedInterface() {
      this.$set(this, "intf", this.autoSavedInterface);
      if (this.intf.steps === undefined) {
        self.intf.steps = [];
      }
      this.list = this.intf.steps;
      this.input = [this.intf.input];
      this.value = this.intf.input;
      this.status = "Loaded";
      this.bvModalAutoSave = false;
    },
    loadProjects(useServerData = false, autoSaved = false) {
      request
        .get("/ingest/list/" + this.$route.query.a)
        .then((res) => {
          this.debugapps = Object.keys(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
      request
        .get("/editor/steps?i=" + this.$route.query.a)
        .then((res) => {
          this.steps = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
      request
        .get("/editor/inputs?i=" + this.$route.query.a)
        .then((res) => {
          this.inputs = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
      let asave = localStorage.getItem("autosave." + this.$route.query.i);
      if (asave) {
        //
      }
      let intf = localStorage.getItem("save401." + this.endpointName);
      if (!intf) {
        request
          .get(
            "/editor/app?c=" +
              this.$route.query.c +
              "&a=" +
              this.$route.query.a +
              "&i=" +
              this.$route.query.i
          )
          .then(async (res) => {
            this.version = res.data.version;
            this.modifier = res.data.modifier;
            if (autoSaved) {
              this.storeInterfaceMetaData();
            }
            this.versions = this.getVersions(res.data.versions);
            const vk = Object.keys(res.data.versions);
            this.versionNumber = vk[vk.length - 1];
            console.log('loaded interface, version', this.versionNumber);
            this.intfCopy = JSON.parse(res.data.data);
            if (useServerData) {
              this.intf = JSON.parse(res.data.data);
              if (this.intf.steps === undefined && self?.intf) {
                self.intf.steps = [];
              }
              this.list = this.intf.steps;
              this.input = [this.intf.input];
              this.value = this.intf.input;
              this.status = "Loaded";
            } else {
              // Compare what was autosaved with our current this.intf value

              await this.compareVersions().then(async (versionConflict) => {
                if (versionConflict === false) {
                  await this.compareAutoSave(res.data.data).then(
                    (autoSaveFalse) => {
                      if (autoSaveFalse === false) {
                        //there are no conflicts
                        this.intf = JSON.parse(res.data.data);

                        if (this.intf.steps === undefined && self?.intf) {
                          self.intf.steps = [];
                        }
                        this.list = this.intf.steps;
                        this.input = [this.intf.input];
                        this.value = this.intf.input;
                        this.status = "Loaded";
                      }
                    }
                  );
                }
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.intf = JSON.parse(intf);
        this.list = this.intf.steps;
        this.input = [this.intf.input];
        this.value = this.intf.input;
        localStorage.removeItem("save401." + this.endpointName);
      }
      request
        .get(
          "/editor/app?c=" +
            this.$route.query.c +
            "&a=" +
            this.$route.query.a +
            "&i=" +
            this.$route.query.e
        )
        .then((res) => {
          const data = JSON.parse(res.data.data);
          this.env = data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    storeInterfaceMetaData() {
      localStorage.setItem(
        "interface.modifier." + this.$route.query.i,
        this.modifier
      );
      localStorage.setItem(
        "interface.version." + this.$route.query.i,
        this.version
      );
    },
    async cancelAutoSave() {
      this.bvModalAutoSave = false;
      localStorage.removeItem("autosave." + this.$route.query.i);
      await this.loadProjects(true);
      this.storeInterfaceMetaData(this.modifier, this.version);
    },
    async cancelAutoSaveConflict() {
      this.bvModalAutoSaveConflict = false;
      localStorage.removeItem("autosave." + this.$route.query.i);
      this.serverModifiedUser = "";
      await this.loadProjects(true);
      this.storeInterfaceMetaData(this.modifier, this.version);
    },
    async compareVersions() {
      if (
        this.storedInterfaceVersion &&
        parseInt(this.storedInterfaceVersion) < this.version
      ) {
        this.serverModifiedUser = this.modifier;
        this.serverVersion = this.version;
        this.bvModalAutoSaveConflict = true;
        return true;
      }
      return false;
    },
    async compareAutoSave(intfData) {
      if (
        this.autoSavedInterface &&
        !isEqual(this.autoSavedInterface, intfData)
      ) {
        this.bvModalAutoSave = true;
        return true;
      }
      return false;
    },
    downloadJSON() {
      this.downloadString(
        JSON.stringify(this.intf, undefined, 2),
        "application/json",
        "job_" + this.interfaceName.replace(" ", "_") + ".json"
      );
    },
    saveAutoSavedInterface() {
      let self = this;
      const intf = this.autoSavedInterface;
      request
        .post(
          "/editor/save?i=" +
            this.$route.query.i +
            "&c=" +
            this.$route.query.c +
            "&a=" +
            this.$route.query.a +
            "&n=" +
            this.$route.query.e,
          intf
        )
        .then(() => {
          self.status = "Saved auto saved version";
          localStorage.removeItem("autosave." + this.$route.query.i);
          this.loadProjects(true, true);
          this.bvModalAutoSave = false;
          this.bvModalAutoSaveConflict = false;
        })
        .catch((error) => {
          localStorage.setItem(
            "save401." + this.endpointName,
            JSON.stringify(this.intf)
          );
          if (!console.log(error)) {
            localStorage.removeItem("save401." + this.endpointName);
          }
          self.status = "Not saved";
        });
    },
    renameInterface() {
      this.$store.dispatch("renameInterface", {
        interface: {
          hash: this.$route.query.i,
          real_name: this.interfaceName,
        },
        newInterfaceName: this.interfaceName,
        clientHash: this.$route.query.c,
        appID: this.$route.query.a,
      });
    },
    saveInterface() {
      let self = this;

      request
        .post(
          "/editor/save?i=" +
            this.$route.query.i +
            "&c=" +
            this.$route.query.c +
            "&a=" +
            this.$route.query.a +
            "&n=" +
            this.$route.query.e,
          this.intf
        )
        .then(() => {
          self.status = "Saved";
          this.snackBarText = "Saved interface";
          this.snackBarStatus = "success";
          this.snackbar = true;
          localStorage.removeItem("autosave." + this.$route.query.i);
          this.loadProjects(false,false);
        })
        .catch((error) => {
          localStorage.setItem(
            "save401." + this.endpointName,
            JSON.stringify(this.intf)
          );
          if (!console.log(error)) {
            localStorage.removeItem("save401." + this.endpointName);
          }
          this.snackBarText = "Saved interface";
          this.snackBarStatus = "Could not save interface";
          this.snackbar = true;
          self.status = "Not saved";
        });
    },
    downloadString(text, fileType, fileName) {
      let blob = new Blob([text], {
        type: fileType,
      });

      let a = document.createElement("a");
      a.download = fileName;
      a.href = URL.createObjectURL(blob);
      a.dataset.downloadurl = [fileType, a.download, a.href].join(":");
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () {
        URL.revokeObjectURL(a.href);
      }, 1500);
    },
    readFile(evt) {
      let self = this;
      if (!window.FileReader) return; // Browser is not compatible

      let reader = new FileReader();

      reader.onload = function (evt) {
        if (evt.target.readyState !== 2) return;
        if (evt.target.error) {
          alert("Error while reading file");
          return;
        }
        try {
          self.intf = JSON.parse(evt.target.result);
        } catch (e) {
          self.snackBarText = "Could not read JSON file";
          self.snackBarStatus = "error";
          self.snackbar = true;
        }
        self.list = self.intf.steps;
        self.input = [self.intf.input];
        self.value = self.intf.input;
        self.uploadmsg =
          "The JSON program file has been read, you can close the form by pressing [esc] or clicking out.";

        self.status = "Imported (not saved)";
        self.uploadJSONDialog = false;
      };

      reader.readAsText(evt.target.files[0]);
      this.clearDataMapperData();

      this.uploadJSONDialog = false;
    },
    pauseQueue(qinfo) {
      this.$store.dispatch("pauseQueue", {
        intfName: this.$route.query.i,
        appid: this.$route.query.a,
        qinfo: qinfo,
      });
    },
    resumeQueue(qinfo) {
      this.$store.dispatch("resumeQueue", {
        intfName: this.$route.query.i,
        appid: this.$route.query.a,
        qinfo: qinfo,
      });
    },
    getContent(qinfo) {
      this.$store.dispatch("getContent", {
        intfName: this.$route.query.i,
        appid: this.$route.query.a,
        qinfo: qinfo,
      });
      this.bvModalEditor = true;
    },
    setContent(qinfo) {
      this.$store.dispatch("setContent", {
        intfName: this.$route.query.i,
        appid: this.$route.query.a,
        qinfo: qinfo,
      });
      this.bvModalEditor = true;
    },
    debugOn() {
      this.$store.dispatch("debugOn", {
        intfName: this.$route.query.i,
        appid: this.$route.query.a,
      });
      this.debug = true;
      this.simbundle = {};
    },
    async debugOff() {
      await this.$store.dispatch("debugOff", this.$route.query.a);
      this.debug = false;
    },
    addStepManual(s) {
      this.simDisable();
      const mname = s.name.replace(/^step_/, "");
      let m = {
        module: mname,
        shortname: s.title.toLowerCase(), // for module named ifstep we just say "if"
      };
      // this.selected = m;
      m[mname] = JSON.parse(JSON.stringify(this.steps[mname].values));
      this.simbundle = {};
      this.list.push(m);
      const length = this.list.length - 1;
      this.$root.$emit("cursor-move", {
        pos: `steps.${length}`,
      });
      setTimeout(() => {
        document.getElementById(`steps-steps.${length}`).scrollIntoView();
      }, 250);
    },
    addStep(s) {
      this.simDisable();
      const mname = s.name.replace(/^step_/, "");
      let m = {
        module: mname,
        shortname: s.title.toLowerCase(), // for module named ifstep we just say "if"
      };
      this.selected = m;
      m[mname] = JSON.parse(JSON.stringify(this.steps[mname].values));
      this.simbundle = {};
      return m;
    },
    delStep(v) {
      this.simDisable();
      this.selected = null;
      this.cursorpos = "";
      if (v.prefix == "step") {
        this.list.splice(v.key, 1);
      } else if (v.prefix == "input") {
        this.intf.input = {};
        this.input = [{}];
      } else {
        const parts = v.prefix.split(":");
        parts.splice(0, 1);
        parts.push(v.key);
        this.delInternal(this.list, parts);
      }
      this.simbundle = {};
    },
    delInternal(list, toDel) {
      if (toDel.length < 2) {
        list.splice(toDel[0], 1);
      } else {
        if (list[toDel[0]].module == "loop") {
          list = list[toDel[0]].loop.steps;
        } else if (list[toDel[0]].module == "ifstep") {
          list = list[toDel[0]].ifstep.steps;
        } else {
          console.log("unhandled deletion");
          return;
        }
        toDel.splice(0, 1);
        if (toDel.length > 0) {
          console.log("recursion");
          this.delInternal(list, toDel);
        }
      }
    },
    setModule(m) {
      this.simDisable();
      this.cursorpos = "";
      if (m.prefix == "input") {
        let newm = { shortname: "handle input", module: m.module };
        newm[m.module] = { shortname: m.label };
        this.intf.input = newm;
        this.input = [newm];
        this.intf.input[m.module] = m.settings.values;
        this.selected = newm;
        let self = this;
        setTimeout(function() { self.cursorMove({pos: 'input.-1'}); }, 300);
        return;
      }
      this.intf.steps[m.mkey] = {
        ...this.intf.steps[m.mkey],
        module: m.module,
        [m.module]: {},
      };
      this.intf.steps.splice(m.mkey + 1, this.intf.steps.length);
    },
    simDelete(v) {
      if (typeof this.simbundle[v.key] == "object") {
        this.simbundle[v.key].splice(v.index, 1);
        this.intfKey = Math.random();
      }
    },
    simPinToggle(v) {
      this.simbundle[v.key][v.index].pinned =
        !this.simbundle[v.key][v.index].pinned;
      this.intfKey = Math.random();
    },
    simDisable() {
      this.simulator = false;
      this.simbundle = {};
    },
    simToggle() {
      this.debugOff();
      if (!this.simulator) {
        this.simbundle = { "input:-1": [] };
        let laststep = "input:-1";
        this.subSimInit("steps", this.intf.steps, null, laststep);
        console.log("prepared", JSON.stringify(this.simbundle));
        this.simulator = true;
        this.intfKey = Math.random();
      } else {
        this.simDisable();
      }
    },
    simEmptyQueue(v) {
      if (typeof this.simbundle[v.key] == "object") {
        this.simbundle[v.key] = [];
        this.intfKey = Math.random();
      }
    },
    simDelFromQueue(v) {
      const appID = this.$route.query.a;
      const interfaceID = this.$route.query.i;
      const queue = v.queue;

      this.$store.dispatch("delFromQueue", {
        interfaceID: interfaceID,
        key: appID,
        appID: appID,
        queue: queue,
      });

      this.simbundle[v.key].splice(v.id, 1);
      this.intfKey = Math.random();
    },
    simStep(v) {
      let k = v.val;
      let prefix = v.prefix;

      let postData = {};
      let bundleindex = "";

      if (k == -1) {
        if (prefix == "steps") {
          prefix = "input";
        }
        postData = {
          t: "input",
          e: v.extra,
          v: v.variables,
          i: v.selectedStep,
          p: prefix + ":" + v.skey,
          c: this.cursorpos.slice(6),
        };
      } else {
        let rprefix = prefix;
        let rk = k - 1;
        if (k < 1 && prefix == "steps") {
          rprefix = "input";
        }
        let qitem = this.simbundle[rprefix + ":" + rk];
        bundleindex = rprefix + ":" + rk;
        postData = {
          t: "step",
          q: qitem,
          e: v.extra,
          v: v.variables,
          s: v.selectedStep,
          p: prefix + ":" + v.skey,
          c: this.cursorpos.slice(6),
        };
      }
      if (postData["b"] === "") {
        postData["b"] = [];
      }
      postData["l"] = map(this.intf.steps, "shortname");

      this.qerr = "";
      request
        .post("/editor/sim?i=" + this.$route.query.i, postData)
        .then((res) => {
          if (
            bundleindex != "" &&
            typeof this.simbundle[bundleindex] == "object" &&
            !this.simbundle[bundleindex][0].pinned
          ) {
            this.simbundle[bundleindex].splice(0, 1);
          }
          if (res.data.count > 0) {
            if (res.data.target != undefined) {
              if (res.data.target == ":-1") {
                this.simPush("input:" + res.data.target, res.data.data);
              } else {
                this.simPush(res.data.target, res.data.data);
              }
            } else {
              this.simPush(prefix + ":" + k, res.data.data);
            }
          }
          this.intfKey = Math.random();
        })
        .catch((error) => {
          this.qerr = error.name;
          console.log("error:", JSON.stringify(error));
        });
    },
    hash(str) {
      // Simple hash function, might result collision
      let hash = 0;
      if (str.length === 0) {
        return hash;
      }
      for (let i = 0; i < str.length; i++) {
        let char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }
      return Math.abs(hash).toString(10);
    },
    simPush(key, values) {
      values.forEach((value) => {
        if (typeof this.simbundle[key] == "string") {
          key = this.simbundle[key]; // symlink
        }
        if (this.simbundle[key] == undefined) {
          this.simbundle[key] = [];
        }
        this.simbundle[key] = this.simbundle[key].concat({
          payload: value,
          hash: this.hash(value),
          pinned: false,
        });
      });
    },
    subSimInit(prefix, steps, parentstep, backlink) {
      const lastidx = steps.length - 1;
      let laststep = backlink;
      for (var index = 0, len = steps.length; index < len; index++) {
        if (index == lastidx && parentstep != null) {
          if (parentstep.module == "ifstep") {
            let nextstep = "";
            if (backlink == "input:-1") {
              nextstep = "steps:0";
            } else {
              let parts = backlink.split(":");
              const li = parseInt(parts[parts.length - 1]);
              parts.splice(-1, 1);
              parts.push(li + 1);
              nextstep = parts.join(":");
            }
            this.simbundle[`${prefix}:${index}`] = nextstep;
          } else {
            this.simbundle[`${prefix}:${index}`] = backlink;
          }
        } else {
          const step = steps[index];
          this.simbundle[`${prefix}:${index}`] = [];
          if (step.module == "ifstep") {
            this.simbundle[`${prefix}:${index}:-1`] = [];
            this.subSimInit(
              `${prefix}:${index}`,
              step.ifstep.steps,
              step,
              laststep
            );
          }
          if (step.module == "loop") {
            this.simbundle[`${prefix}:${index}:-1`] = [];
            this.subSimInit(
              `${prefix}:${index}`,
              step.loop.steps,
              step,
              laststep
            );
          }
        }
        laststep = `${prefix}:${index}`;
      }
    },
    changed() {
      this.intfKey = Math.random();
    },
    begin() {
      this.$root.$emit("on-move", { onMove: true });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./EditInterface.scss";

.vermenu {
  max-height: 250px;
  overflow: auto;
}
.xsmall {
  font-size: 10px;
  text-align: right;
}
</style>
